import { plugin as Base } from '@apptegy/base';
import { plugin as Containers } from '@apptegy/containers';
import { plugin as Forms } from '@apptegy/forms';
import { plugin as Navigation } from '@apptegy/navigation';
import { plugin as Icons } from '@apptegy/icons';
import { plugin as Table } from '@apptegy/table';
import { plugin as TextEditor } from '@apptegy/text-editor';
//  import { plugin as Themes } from '@apptegy/themes';

import '@apptegy/base/dist/style.css';
import '@apptegy/containers/dist/style.css';
import '@apptegy/forms/dist/style.css';
import '@apptegy/navigation/dist/style.css';
import '@apptegy/table/dist/style.css';
import '@apptegy/text-editor/dist/style.css';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(Base);
  vueApp.use(Containers);
  vueApp.use(Forms);
  vueApp.use(Navigation);
  vueApp.use(Icons);
  vueApp.use(Table);
  vueApp.use(TextEditor);
  // vueApp.use(Themes);
});
